import { createContext } from 'react';
import type { Season } from './season';
import type { SeasonPackage } from './types';
import type { Theme } from '@src/theme/theme';

export interface ThemeContextValue {
  season: Season;
  seasonPackage: SeasonPackage;
  /** Resolves after loading; a failed download leaves the current scene intact. */
  setSeason: (season: Season, options?: { persist?: boolean }) => Promise<void>;
  setSeasonOverride: (season: Season | null) => void;
  theme: Theme;
  setTheme: (theme: Theme, options?: { persist?: boolean }) => void;
  preference: Theme | 'auto';
  setPreference: (preference: Theme | 'auto') => void;
  /** Toggle explicit light/dark preferences. */
  toggleTheme: () => void;
}

/** null means "no provider above" — useTheme turns that into a clear error. */
export const ThemeContext = createContext<ThemeContextValue | null>(null);
